import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const MAX_FONT_PX = 56;
const MIN_FONT_PX = 16;
const VIDEO_PAD_PX = 12;

class HomeButtons extends React.Component {
  constructor(props) {
    super(props);
    this.wrapRef = React.createRef();
    this.headingRef = React.createRef();
    this.fitFont = this.fitFont.bind(this);
  }

  componentDidMount() {
    this.fitFont();
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(this.fitFont);
      const wrap = this.wrapRef.current;
      const vidWrap = wrap && wrap.closest('.Vid-wrap');
      if (wrap) this.resizeObserver.observe(wrap);
      if (vidWrap) this.resizeObserver.observe(vidWrap);
    }
    window.addEventListener('resize', this.fitFont);
  }

  componentWillUnmount() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    window.removeEventListener('resize', this.fitFont);
  }

  fitsInVideo(wrap, vidWrap) {
    const wrapRect = wrap.getBoundingClientRect();
    const vidRect = vidWrap.getBoundingClientRect();
    return (
      wrapRect.top >= vidRect.top + VIDEO_PAD_PX &&
      wrapRect.bottom <= vidRect.bottom - VIDEO_PAD_PX &&
      wrapRect.left >= vidRect.left + VIDEO_PAD_PX &&
      wrapRect.right <= vidRect.right - VIDEO_PAD_PX
    );
  }

  fitFont() {
    const wrap = this.wrapRef.current;
    const heading = this.headingRef.current;
    if (!wrap || !heading) return;

    const vidWrap = wrap.closest('.Vid-wrap');
    if (!vidWrap || vidWrap.clientWidth === 0) return;

    // Start from a size that scales with video width, then shrink until overlay fits.
    let size = Math.min(MAX_FONT_PX, Math.max(MIN_FONT_PX, vidWrap.clientWidth * 0.085));
    heading.style.fontSize = `${size}px`;

    while (size > MIN_FONT_PX && !this.fitsInVideo(wrap, vidWrap)) {
      size -= 1;
      heading.style.fontSize = `${size}px`;
    }
  }

  render() {
    return (
      <div ref={this.wrapRef} className="Center-column home-btns">
        <h1 ref={this.headingRef} className="Page-header Home-header">
          <strong>100% natural</strong>, <strong>organic</strong> hair &
          skin care for all!
        </h1>
        <Link to={'/shop-all'} className="Home-header">
          <Button variant="success" size="lg">
            Shop Now
          </Button>
        </Link>
      </div>
    );
  }
}

export default HomeButtons;
